module.exports = __webpack_public_path__ + "static/media/csarnok-y-szektor-kft.0cf4635e.jpg";